import Vue from 'vue'
import VueRouter from 'vue-router'
import DateTool from "@/components/menu/tools/DateTool";
import DouyinTool from "@/components/menu/tools/DouyinTool";
import ContryList from "@/components/menu/tools/ContryList";
import ContryDetails from "@/components/menu/tools/ContryDetails";
import BirthdayDetails from "@/components/menu/birthday/BirthdayDetails";
import CirclePage from "@/components/menu/Circle/CirclePage";
import CircleBirthday from "@/components/menu/Circle/CircleBirthday";
import CircleManager from "@/components/menu/Circle/CircleManager";
import CircleDetails from "@/components/menu/Circle/CircleDetails";
import AddCircle from "@/components/menu/Circle/AddCircle";
import CreateCircle from "@/components/menu/Circle/CreateCircle";
import ImportBirthday from "@/components/menu/Circle/ImportBirthday";
import TangshiSongci from "@/components/menu/tools/TangshiSongci";
import UpdateBirthday from "@/components/menu/Circle/UpdateBirthday";
import Login from "@/components/login/Login";
import WeiBoCallback from "@/components/login/WeiBoCallback";
import BaiDuCallback from "@/components/login/BaiDuCallback";
import QQCallback from "@/components/login/QQCallback";
import AlipayCallback from "@/components/login/AlipayCallback";
import Birthday from "@/components/menu/birthday/Birthday";
import HistoricalEvent from "@/components/menu/tools/HistoricalEvent";
import HistoricalEventDetails from "@/components/menu/tools/HistoricalEventDetails";
import BirthdayManager from "@/components/menu/birthday/BirthdayManager";
import BirthdayAdd from "@/components/menu/birthday/BirthdayAdd";
import NewMoment from "@/components/menu/moment/NewMoment";
import Mine from "@/components/menu/mine/Mine";
import MyInfo from "@/components/menu/mine/MyInfo";
import AvatarEditor from "@/components/menu/mine/AvatarEditor";
import SystemSetting from "@/components/menu/mine/setting/SystemSetting";
import LifeTool from "@/components/menu/tools/LifeTool";
import AccountSetting from "@/components/menu/mine/setting/AccountSetting";
import AuthSetting from "@/components/menu/mine/setting/AuthSetting";
import SecuritySetting from "@/components/menu/mine/setting/SecuritySetting";
import ChangeNewPhone from "@/components/menu/mine/setting/ChangeNewPhone";
import BindingPhone from "@/components/menu/mine/setting/BindingPhone";
import LicensePlate from "@/components/menu/tools/LicensePlate";
import Recipe from "@/components/menu/tools/Recipe";
import RecipeDetails from "@/components/menu/tools/RecipeDetails";
import VerificationCode from "@/controls/VerificationCode";
import AfterVerification from "@/components/menu/mine/setting/AfterVerification";
import ManagerMain from "@/components/manager/ManagerMain";
import CircleUser from "@/components/menu/Circle/CircleUser";
import ShiCiDetails from "@/components/menu/tools/ShiCiDetails";
import StarBirthday from "@/components/menu/tools/StarBirthday/StarBirthday";
import AddStarBirthday from "@/components/menu/tools/StarBirthday/AddStarBirthday";
import StarBirthdayDetails from "@/components/menu/tools/StarBirthday/StarBirthdayDetails";
import StarBirthdayManager from "@/components/menu/tools/StarBirthday/StarBirthdayManager";
import Joke from "@/components/menu/tools/Joke";
import CheckPicture from "@/components/manager/CheckPicture";
import BirthdayHoliday from "@/components/menu/tools/BirthdayHoliday";
import ShiCiSearch from "@/components/menu/tools/ShiCiSearch";
import StarMain from "@/components/menu/tools/Star/StarMain";
import YueFuDetails from "@/components/menu/tools/YueFuDetails";
import Village from "@/components/menu/tools/Village";
import VillageDetails from "@/components/menu/tools/VillageDetails";
import VillageSearch from "@/components/menu/tools/VillageSearch";
import Region from "@/components/menu/tools/Region";
import RegionSearch from "@/components/menu/tools/RegionSearch";
import Airport from "@/components/menu/tools/Airport";
import AirportDetails from "@/components/menu/tools/AirportDetails";
import AirportList from "@/components/menu/tools/AirportList";
import Search from "@/controls/Search";
import BingMap from "@/components/menu/tools/Map/BingMap";
import ScenicSpot from "@/components/menu/tools/View/ScenicSpot";
import ViewGroup from "@/components/menu/tools/View/ViewGroup";
import ViewDetails from "@/components/menu/tools/View/ViewDetails";
import StarHotel from "@/components/menu/tools/StarHotel";
import HotelMap from "@/components/menu/tools/HotelMap";
import HotelDetails from "@/components/menu/tools/HotelDetails";
import FinshingMain from "@/components/menu/tools/Fishing/FinshingMain";
import FishingList from "@/components/menu/tools/Fishing/FishingList";
import QzoneTool from "@/components/menu/other/qzone/QzoneTool";
import QZoneLogin from "@/components/menu/other/qzone/QZoneLogin.vue";
import WechatLogin from "@/components/menu/other/wechat/WechatLogin.vue";
import TravelManager from "@/components/menu/other/gjjl/TravelManager.vue";

Vue.use(VueRouter)

const createRouter = () => new VueRouter({
    mode: "history",
    routes: [
        {
            path: '/',
            redirect: '/m_login'
        },
        {
            path: '/m_login',
            name: 'm_login',
            component: Login,
            meta: {title: '登录', requireAuth: false, showMenu: false}
        },
        {
            path: '/weibo/callback',
            name: 'WeiBoCallback',
            component: WeiBoCallback,
            meta: {title: '登录中', requireAuth: false, showMenu: false}
        },
        {
            path: '/baidu/callback',
            name: 'BaiDuCallback',
            component: BaiDuCallback,
            meta: {title: '登录中', requireAuth: false, showMenu: false}
        },
        {
            path: '/alipay/callback',
            name: 'AlipayCallback',
            component: AlipayCallback,
            meta: {title: '登录中', requireAuth: false, showMenu: false}
        },
        {
            path: '/qq/callback',
            name: 'QQCallback',
            component: QQCallback,
            meta: {title: '登录中', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_birthday',
            name: 'm_birthday',
            component: Birthday,
            meta: {title: '生日', requireAuth: true, showMenu: true}
        },
        {
            path: '/m_historical_event',
            name: 'm_historical_event',
            component: HistoricalEvent,
            meta: {title: '历史上的今天', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_historical_event_details',
            name: 'm_historical_event_details',
            component: HistoricalEventDetails,
            meta: {title: '图文详情', requireAuth: false, showMenu: false}
        },
        {//to 1
            path: '/m_bmanager',
            name: 'm_bmanager',
            component: BirthdayManager,
            meta: {title: '生日管理', requireAuth: true, showMenu: false}
        },
        {//push 1 to 1
            path: '/m_birthday_add',
            name: 'm_birthday_add',
            component: BirthdayAdd,
            meta: {title: '添加生日', requireAuth: true, showMenu: false}
        },
        {
            path: '/m_update_birthday',
            name: 'm_update_birthday',
            component: UpdateBirthday,
            meta: {title: '修改生日', requireAuth: true, showMenu: false}
        },
        {
            path: '/m_add_circle',
            name: 'm_add_circle',
            component: AddCircle,
            meta: {title: '添加圈子', requireAuth: true, showMenu: false}
        }, {
            path: '/m_create_circle',
            name: 'm_create_circle',
            component: CreateCircle,
            meta: {title: '创建圈子', requireAuth: true, showMenu: false}
        }, {
            path: '/m_import_birthday',
            name: 'm_import_birthday',
            component: ImportBirthday,
            meta: {title: '导入生日', requireAuth: true, showMenu: false}
        },
        {//push 1 to 1
            path: '/m_birthday_details',
            name: 'm_birthday_details',
            component: BirthdayDetails,
            meta: {title: '生日详情', requireAuth: true, showMenu: false}
        },
        {//replace
            path: '/m_moment',
            name: 'm_moment',
            component: NewMoment,
            meta: {title: '轨迹', requireAuth: true, showMenu: true}
        },
        {//replace
            path: '/m_circle',
            name: 'm_circle',
            component: CirclePage,
            meta: {title: '圈子', requireAuth: true, showMenu: true}
        },
        {//replace
            path: '/m_circle_manager',
            name: 'm_circle_manager',
            component: CircleManager,
            meta: {title: '圈子管理', requireAuth: true, showMenu: false}
        },
        {//replace
            path: '/m_circle_details',
            name: 'm_circle_details',
            component: CircleDetails,
            meta: {title: '圈子详情', requireAuth: true, showMenu: false}
        },
        {//replace
            path: '/m_circle_birthday',
            name: 'm_circle_birthday',
            component: CircleBirthday,
            meta: {title: '生日列表', requireAuth: true, showMenu: false}
        },
        {//replace
            path: '/m_mine',
            name: 'm_mine',
            component: Mine,
            meta: {title: '我的', requireAuth: true, showMenu: true}
        },
        {//push 1 go 1
            path: '/m_myinfo',
            name: 'm_myinfo',
            component: MyInfo,
            meta: {title: '修改资料', requireAuth: true, showMenu: false}
        },
        {//push 1
            path: '/m_avatar_editor',
            name: 'm_avatar_editor',
            component: AvatarEditor,
            meta: {title: '头像修改', requireAuth: true, showMenu: false}
        },
        {//to 1
            path: '/m_setting',
            name: 'm_setting',
            component: SystemSetting,
            meta: {title: '系统设置', requireAuth: true, showMenu: false}
        },
        {//to 1
            path: '/m_tool',
            name: 'm_tool',
            component: LifeTool,
            meta: {title: '工具', requireAuth: true, showMenu: true}
        },
        {//to 1
            path: '/m_account_setting',
            name: 'm_account_setting',
            component: AccountSetting,
            meta: {title: '帐号设置', requireAuth: true, showMenu: false}
        },
        {//to 1
            path: '/m_auth_setting',
            name: 'm_auth_setting',
            component: AuthSetting,
            meta: {title: '权限设置', requireAuth: true, showMenu: false}
        },
        {//to 1
            path: '/m_security_setting',
            name: 'm_security_setting',
            component: SecuritySetting,
            meta: {title: '安全设置', requireAuth: true, showMenu: false}
        },
        {//replace
            path: '/m_change_new_phone',
            name: 'm_change_new_phone',
            component: ChangeNewPhone,
            meta: {title: '更换手机号码', requireAuth: true, showMenu: false}
        },
        {//replace
            path: '/m_binding_phone',
            name: 'm_binding_phone',
            component: BindingPhone,
            meta: {title: '绑定手机号码', requireAuth: true, showMenu: false}
        },
        {//replace
            path: '/m_license_plate',
            name: 'm_license_plate',
            component: LicensePlate,
            meta: {title: '车牌简称', requireAuth: false, showMenu: false}
        },
        {//replace
            path: '/m_recipe',
            name: 'm_recipe',
            component: Recipe,
            meta: {title: '菜谱大全', requireAuth: false, showMenu: false}
        },
        {//replace
            path: '/m_recipe_details',
            name: 'm_recipe_details',
            component: RecipeDetails,
            meta: {title: '菜谱详情', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_verification_code',
            name: 'm_verification_code',
            component: VerificationCode,
            meta: {title: '短信验证码', requireAuth: true, showMenu: false}
        },
        {
            path: '/m_after_verification',
            name: 'm_after_verification',
            component: AfterVerification,
            meta: {title: '', requireAuth: true, showMenu: false}
        },
        {
            path: '/m_joke',
            name: 'm_joke',
            component: Joke,
            meta: {title: '笑话大全', requireAuth: false, showMenu: false}
        },
        {
            path: '/travel_manager',
            name: 'travel_manager',
            component: TravelManager,
            meta: {title: '轨迹记录后台', requireAuth: true, showMenu: false}
        },
        {
            path: '/qzone_login',
            name: 'qzone_login',
            component: QZoneLogin,
            meta: {title: 'QQ空间登录', requireAuth: false, showMenu: false}
        },
        {
            path: '/qzone_tool',
            name: 'qzone_tool',
            component: QzoneTool,
            meta: {title: 'QQ空间工具箱', requireAuth: false, showMenu: false}
        },
        {
            path: '/wechat_login',
            name: 'wechat_login',
            component: WechatLogin,
            meta: {title: '微信扫码登录', requireAuth: false, showMenu: false}
        },
        {
            path: '/manager_main',
            name: 'manager_main',
            component: ManagerMain,
            meta: {title: '后台管理', requireAuth: true, showMenu: false}
        }, {
            path: '/manager_picture',
            name: 'manager_picture',
            component: CheckPicture,
            meta: {title: '图片检查', requireAuth: true, showMenu: false}
        },
        {
            path: '/m_circle_user',
            name: 'm_circle_user',
            component: CircleUser,
            meta: {title: '圈子用户', requireAuth: true, showMenu: false}
        },
        {
            path: '/m_date_tool',
            name: 'm_date_tool',
            component: DateTool,
            meta: {title: '日期计算', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_birthday_holiday',
            name: 'm_birthday_holiday',
            component: BirthdayHoliday,
            meta: {title: '生日与节日重合计算', requireAuth: false, showMenu: false}
        }, {
            path: '/m_star_birthday_manager',
            name: 'm_star_birthday_manager',
            component: StarBirthdayManager,
            meta: {title: '明星生日管理', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_douyin_tool',
            name: 'm_douyin_tool',
            component: DouyinTool,
            meta: {title: '抖音去水印', requireAuth: false, showMenu: false}
        }, {
            path: '/m_star_birthday',
            name: 'm_star_birthday',
            component: StarBirthday,
            meta: {title: '明星生日', requireAuth: false, showMenu: false}
        }, {
            path: '/m_add_star_birthday',
            name: 'm_add_star_birthday',
            component: AddStarBirthday,
            meta: {title: '添加明星生日', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_star_birthday_details',
            name: 'm_star_birthday_details',
            component: StarBirthdayDetails,
            meta: {title: '明星生日详情', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_contry_list',
            name: 'm_contry_list',
            component: ContryList,
            meta: {title: '世界各国', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_tangshi_songci',
            name: 'm_tangshi_songci',
            component: TangshiSongci,
            meta: {title: '唐诗宋词', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_shici_search',
            name: 'm_shici_search',
            component: ShiCiSearch,
            meta: {title: '诗词曲搜索', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_shici_details',
            name: 'm_shici_details',
            component: ShiCiDetails,
            meta: {title: '详细信息', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_contry_details',
            name: 'm_contry_details',
            component: ContryDetails,
            meta: {title: '国家详情', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_star_main',
            name: 'm_star_main',
            component: StarMain,
            meta: {title: '明星主页', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_yuefu_details',
            name: 'm_yuefu_details',
            component: YueFuDetails,
            meta: {title: '乐府诗集详情', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_village',
            name: 'm_village',
            component: Village,
            meta: {title: '全国行政村', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_village_details',
            name: 'm_village_details',
            component: VillageDetails,
            meta: {title: '村详情', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_village_search',
            name: 'm_village_search',
            component: VillageSearch,
            meta: {title: '搜索村信息', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_region',
            name: 'm_region',
            component: Region,
            meta: {title: '全国行政区划', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_region_search',
            name: 'm_region_search',
            component: RegionSearch,
            meta: {title: '搜索地址', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_airport',
            name: 'm_airport',
            component: Airport,
            meta: {title: '国内机场', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_airport_details',
            name: 'm_airport_details',
            component: AirportDetails,
            meta: {title: '机场详情', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_airport_list',
            name: 'm_airport_list',
            component: AirportList,
            meta: {title: '机场列表', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_search',
            name: 'm_search',
            component: Search,
            meta: {title: '搜索', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_bing_map',
            name: 'm_bing_map',
            component: BingMap,
            meta: {title: '机场地图', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_view',
            name: 'm_view',
            component: ScenicSpot,
            meta: {title: '全国5A景区', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_view_group',
            name: 'm_view_group',
            component: ViewGroup,
            meta: {title: '各省5A景区', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_view_details',
            name: 'm_view_details',
            component: ViewDetails,
            meta: {title: '景区详情', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_hotel',
            name: 'm_hotel',
            component: StarHotel,
            meta: {title: '全国5星级酒店', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_hotel_map',
            name: 'm_hotel_map',
            component: HotelMap,
            meta: {title: '全国5星级酒店地图', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_hotel_details',
            name: 'm_hotel_details',
            component: HotelDetails,
            meta: {title: '酒店详情', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_fishing_main',
            name: 'm_fishing_main',
            component: FinshingMain,
            meta: {title: '钓鱼圈主页', requireAuth: false, showMenu: false}
        },
        {
            path: '/m_fishing_list',
            name: 'm_fishing_list',
            component: FishingList,
            meta: {title: '城市列表', requireAuth: false, showMenu: false}
        }
    ]
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // the relevant part
}

export {router as router}

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.path === '/m_verification_code' && from.path === '/') {
        next('/m_login')
    }
    let islogin = localStorage.getItem('islogin')
    islogin = Boolean(Number(islogin))
    if (to.path === '/m_login') {
        if (islogin) {
            next({path: '/m_birthday', replace: true})
        }
    } else {
        // requireAuth:可以在路由元信息指定哪些页面需要登录权限
        if (to.meta.requireAuth && !islogin) {
            next('/m_login')
            location.reload()
        } //else if (to.meta.requireAuth && islogin) {
        //let loginTime = parseInt(localStorage.getItem('loginTime'))
        //let currentTime = new Date().getTime();
        //let loginMinutes = (currentTime - loginTime) / 1000 / 60
        //if (loginMinutes > 30) {
        //localStorage.setItem('islogin', '0')
        //next('/m_login')
        //}
        //}
    }
    next()
})
